import { useQuery } from '@tanstack/react-query';
import { WorkoutTemplateEntry } from '../../../Model/Explore/WorkoutTemplateEntry';
import { CoachWorkout } from '../../../Model/Coach/Program/Workout/CoachWorkout';
import { runInAction } from 'mobx';
import { EMPTY_ARRAY } from '../../../Utils/Constants';
import { getLocalizedMedia } from '../../../Hooks/useLocalizedMedia';

export type UseGeneratedWorkoutOptions = {
  entry: WorkoutTemplateEntry;
  enabled?: boolean;
};

export function useGeneratedWorkout({ entry, enabled = true }: UseGeneratedWorkoutOptions) {
  return useQuery({
    queryKey: ['workoutTemplate', 'generate', entry.id],
    queryFn: async (): Promise<CoachWorkout> => {
      const result = await entry.generate();
      runInAction(() => {
        result.image = getLocalizedMedia(entry.images);
        result.name = entry?.name ?? EMPTY_ARRAY;
      });
      return result;
    },
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
